module.exports = __webpack_public_path__ + "static/img/图层32.0d43ee6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层32.png
// module id = 3BeG
// module chunks = 0